module.exports = __webpack_public_path__ + "static/media/ico_arrow_down.a4770105.svg";